import { render } from "./LogAccessList.vue?vue&type=template&id=a8a295ea"
import script from "./LogAccessList.vue?vue&type=script&lang=js"
export * from "./LogAccessList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bauminas/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__